__turbopack_context__.v({
  "bounce": "Spinner-module__vk9DPW__bounce",
  "bounce1": "Spinner-module__vk9DPW__bounce1",
  "bounce2": "Spinner-module__vk9DPW__bounce2",
});
